export default __webpack_public_path__ + "static/mobile-application-enhancing-sports-betting-experience-23b2e49395664fc1dd43e7dc3d8cbdec.png";